import React, { useState } from "react";
import {
  ChevronDown,
  Link as LinkIcon,
  CheckCircle,
  XCircle,
} from "lucide-react";
import { FILE_BASE_URL } from "../api/fileServer";

export default function QuestionCard({
  q,
  onMarks,
  onOptionMarks,
  onVerify,
  onRemark,
}) {
  const [open, setOpen] = useState(true);

  const verified = q.isVerified;

  const pillClass = verified
    ? "bg-emerald-50 text-emerald-600"
    : "bg-red-50 text-red-600";

  const pillLabel = verified
    ? "✔ Verified"
    : "✖ Pending";

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">

      <div
        className="flex items-center gap-3 px-5 py-4 cursor-pointer"
        onClick={() => setOpen(!open)}
      >

        <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center font-bold">
          {q.sectionNo}
        </div>

        <div className="flex-1">

          <div className="font-semibold">

            {q.title}

          </div>

          {q.subtitle && (

            <div className="text-xs text-slate-500">

              {q.subtitle}

            </div>

          )}

        </div>

        <div className="text-xs bg-slate-100 rounded px-3 py-1">

          {q.maxMarks} Marks

        </div>

        <span
          className={`text-xs px-3 py-1 rounded-full ${pillClass}`}
        >
          {pillLabel}
        </span>

        <ChevronDown
          size={18}
          className={open ? "rotate-180" : ""}
        />

      </div>

      {open && (

        <div className="border-t p-5">

          <h4 className="font-semibold mb-3">
            Uploaded Files
          </h4>

          {q.files.length === 0 && (
            <div className="text-sm text-slate-400">
              No files uploaded.
            </div>
          )}

          <div className="grid gap-3">

            {q.files.map(file => (

              <div
                key={file.fileId}
                className="border rounded-lg p-3 flex justify-between items-center"
              >

                <div>

                  <div className="font-medium">

                    {file.fileName}

                  </div>

                  <div className="text-xs text-slate-500">

                    {file.filePath}

                  </div>

                </div>

                <a
                  href={`${FILE_BASE_URL}${file.filePath}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-600 flex items-center gap-1"
                >
                  <LinkIcon size={15} />
                  View
                </a>

              </div>

            ))}

          </div>

          <div className="grid md:grid-cols-2 gap-5 mt-5">

            <div>

              <label className="text-xs font-semibold text-slate-500">
                Teacher Marks
              </label>

              <input
                value={q.obtainedMarks}
                disabled
                className="w-full mt-1 border rounded-lg px-3 py-2 bg-slate-100"
              />

            </div>

            {q.sectionNo !== 24 ? (

              <div>

                <label className="text-xs font-semibold text-slate-500">
                  Reviewed Marks
                </label>

                <input
                  type="number"
                  min={0}
                  max={q.maxMarks}
                  value={q.reviewedMarks}
                  onChange={(e) =>
                    onMarks(q.sectionId, e.target.value)
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2"
                />

              </div>

            ) : (

              <div>

                <label className="text-xs font-semibold text-slate-500 mb-2 block">
                  Option Wise Marks
                </label>

                <div className="space-y-3">

                  {q.options.map(option => (

                    <div
                      key={option.optionId}
                      className="flex items-center justify-between gap-4 border rounded-lg p-3"
                    >

                      <div className="flex-1">

                        <div className="text-sm">

                          {option.displayText}

                        </div>

                        <div className="text-xs text-slate-500">

                          Maximum : {option.maxMarks}

                        </div>

                      </div>

                      <input
                        type="number"
                        min={0}
                        max={option.maxMarks}
                        step="0.5"
                        value={option.reviewedMarks}
                        onChange={(e) =>
                          onOptionMarks(
                            q.sectionId,
                            option.optionId,
                            e.target.value
                          )
                        }
                        className="w-24 border rounded-lg px-2 py-2"
                      />

                    </div>

                  ))}

                </div>

              </div>

            )}

          </div>

          <div className="flex gap-3 mt-5">

            <button
              onClick={() =>
                onVerify(
                  q.sectionId,
                  true
                )
              }
              className={`flex items-center gap-2 px-4 py-2 rounded-lg ${q.isVerified
                ? "bg-green-600 text-white"
                : "border"
                }`}
            >
              <CheckCircle size={18} />
              Accept
            </button>

            <button
              onClick={() =>
                onVerify(
                  q.sectionId,
                  false
                )
              }
              className={`flex items-center gap-2 px-4 py-2 rounded-lg ${!q.isVerified
                ? "bg-red-600 text-white"
                : "border"
                }`}
            >
              <XCircle size={18} />
              Reject
            </button>

          </div>

          <div className="mt-5">

            <label className="text-xs font-semibold text-slate-500">
              Remarks
            </label>

            <textarea
              value={q.remark ?? ""}
              onChange={(e) =>
                onRemark(
                  q.sectionId,
                  e.target.value
                )
              }
              className="w-full mt-2 border rounded-lg p-3"
              rows={4}
            />

          </div>

        </div>

      )}

    </div>
  );
}